import { HotelSearchRequest } from '@/__generated';
import BookmarkHotels from '@/components/App/BookmarkHotels';
import DefaultHeader from '@/components/App/Header/DefaultHeader';
import HomeBannerSlider from '@/components/App/HomeBannerSlider';
import PickOfThisWeek from '@/components/App/PickOfThisWeek';
import PopularHotels from '@/components/App/PopularHotels';
import SearchBox from '@/components/App/SearchBox/SearchBox';
import { SearchBoxBackgroundImage } from '@/config';
import { generateHotelSearchUrl } from '@/urls';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export default function HomePage() {
  const { t } = useTranslation();
  const history = useHistory();

  const onSearchHotel = (request: HotelSearchRequest) => {
    let url = generateHotelSearchUrl(request);
    history.push(url);
  };

  return (
    <>
      <Helmet>
        <title>NTA Omega</title>
      </Helmet>
      <DefaultHeader isSticky />
      <div className="header-margin" />
      <section className="masthead -type-1 z-5">
        <div className="masthead__bg">
          <img alt="logo" src={SearchBoxBackgroundImage} className="js-lazy" />
        </div>
        <div className="container">
          <div className="row justify-center">
            <div className="col-12">
              <div className="text-center">
                <h1 className="text-30 text-white" data-aos="fade-up">
                  {t('homePage_SearchTitle')}
                </h1>
              </div>
              <div className="position-relative mt-20">
                <div className="mainSearch w-100 bg-white px-10 py-10 lg:px-20 lg:pt-5 lg:pb-20 rounded-100">
                  <SearchBox onSearchHotel={onSearchHotel} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HomeBannerSlider />
      <PickOfThisWeek />
      <PopularHotels />
    </>
  );
}
